import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { METRIC, HYBRID, KILOJOULES, KILOCALORIES, JOULES, SHORT } from '../constants'

export function getEnergyTo ({ to, system }) {
  if (to) { return to }
  return (system === METRIC || system === HYBRID) ? KILOJOULES : KILOCALORIES
}

export function formatEnergy ({ from = JOULES, unit = SHORT, digits = 0, to: _to, system, ...rest } = {}) {
  const to = getEnergyTo({ from, to: _to, system })
  return formatUnit({ ...rest, from, to, unit, digits })
}

export function energyFormatter ({ intl, locale, system } = {}) {
  return ({ ...options }) => formatEnergy({ ...options, intl, locale, system })
}

export class FormattedEnergy extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([ JOULES, KILOCALORIES, KILOJOULES ]),
    to: PropTypes.oneOf([ JOULES, KILOCALORIES, KILOJOULES ]),
  };

  static defaultProps = {
    from: JOULES,
    unit: SHORT,
    digits: 1,
  };

  render () {
    const { to: _to, ...rest } = this.props
    const to = getEnergyTo({ to: _to, system: this.context.system })
    return React.createElement(FormattedUnit, { ...rest, to })
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/energy.js